import Index from './index.vue'
import Dashboard from './views/Dashboard.vue'
import pnlReport from './views/pnlReport.vue'
import Profile from '@/pages/Report/views/Profile.vue'
import BatchSelection from '@/pages/Report/views/BatchSelection.vue'
import BatchReport from '@/pages/Report/views/BatchReport.vue'
import InvoiceListView from '@/pages/Report/views/InvoiceView.vue'
import RepairView from '@/pages/Report/views/RepairView.vue'
// import SubCategoryList from '@/pages/Report/views/SubCategoryList.vue'


export default [
  {
    path: '/report',
    name: 'report',
    component: Index,
    title: 'report',
    redirect: { name: 'report-dashboard' },
    children: [
      {
        path: 'home',
        name: 'report-dashboard',
        component: Dashboard,
      },
      {
        path: 'pnlReport',
        name: 'pnlReport-dashboard',
        component: pnlReport,
      },
      {
        path: 'invoices',
        name: 'invoice-list',
        component: InvoiceListView,
      },
      {
        path: 'openRepairList',
        name: 'openRepair-list',
        component: RepairView,
      },
      {
        path: 'batchSelection',
        name: 'Batch-selection',
        component: BatchSelection,
        props: true,
      },
      
      // {
      //   path: 'subCategory',
      //   name: 'sub-category',
      //   component: SubCategoryList,
      //   props: true,
      // },
      {
        path: 'batch',
        name: 'batch-report',
        component: BatchReport,
        props: true,
      },
      {
        path: 'profile',
        name: 'report-profile',
        component: Profile,
        props: true,
      },
    ],
  },
]
